<div class="list-data-right">
  <div class="list-main">
    <div class="all-item-cards">
      @for (advert of adverts; track advert.id) {
        <app-feature-card [advert]="advert"></app-feature-card>
      }
    </div>
  </div>
</div>
